/**
 * Query key factory for shared resources.
 *
 * Convention (see README.md): keys are arrays rooted at the plural resource
 * name, then 'list' | 'detail' | <sub-resource>, then params. Invalidate a
 * whole resource with its root (`queryKeys.applications.all`).
 * Feature areas define keys for their own resources in
 * src/features/<area>/api.ts using the same shape.
 */
import type { StatsRange } from './types'

export interface ListParams {
  app?: string
  q?: string
  limit?: number
  [filter: string]: string | number | boolean | undefined
}

export const queryKeys = {
  me: ['me'] as const,
  applications: {
    all: ['applications'] as const,
    list: (params: ListParams = {}) => ['applications', 'list', params] as const,
    detail: (id: string) => ['applications', 'detail', id] as const,
  },
  templates: {
    all: ['templates'] as const,
    list: (params: ListParams = {}) => ['templates', 'list', params] as const,
    detail: (id: string) => ['templates', 'detail', id] as const,
  },
  eventTypes: {
    all: ['event-types'] as const,
    list: (params: ListParams = {}) => ['event-types', 'list', params] as const,
    detail: (id: string) => ['event-types', 'detail', id] as const,
  },
  stats: {
    all: ['stats'] as const,
    overview: (params: { app?: string; range: StatsRange; includeTest?: boolean }) =>
      ['stats', 'overview', params] as const,
  },
  system: {
    info: ['system', 'info'] as const,
  },
} as const
